/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultYandexGamesMerchantData interface.
 */
export function instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultYandexGamesMerchantData(value) {
    if (!('StoreSpecificOrderProductSku' in value) || value['StoreSpecificOrderProductSku'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultYandexGamesMerchantDataFromJSON(json) {
    return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultYandexGamesMerchantDataFromJSONTyped(json, false);
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultYandexGamesMerchantDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'StoreSpecificOrderProductSku': json['StoreSpecificOrderProductSku'],
    };
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultYandexGamesMerchantDataToJSON(json) {
    return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultYandexGamesMerchantDataToJSONTyped(json, false);
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultYandexGamesMerchantDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'StoreSpecificOrderProductSku': value['StoreSpecificOrderProductSku'],
    };
}
//# sourceMappingURL=FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultYandexGamesMerchantData.js.map